<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Sm8eIV/tc-custom/9781504061896.jpg?1701633842385" alt="This image is the cover for the book When the Sleeper Wakes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When the Sleeper Wakes
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>The Invisible Man</i> and <i>The War of the Worlds</i>: “Everyone who has ever read <i>When the Sleeper Wakes</i> remembers it” (George Orwell).</b><br/>  <br/> One of the founding fathers of science fiction, H. G. Wells is known for such landmark novels as <i>The Time Machine</i> and <i>The Island of Doctor Moreau</i>. In <i>When the Sleeper Wakes</i>, he sends a nineteenth-century man hurtling into an unfamiliar dystopian future . . .<br/>  <br/> In 1890s England, Graham, a fanatic socialist and author of prophetic writings, takes medication for his insomnia and is plunged into a deep sleep that lasts two hundred years. He awakens in a domed twenty-second-century London in which he has become—due to the compound interest on his bank accounts—the richest man in the world.<br/>  <br/> But as a nightmarish caste system is revealed, Graham realizes all his worst fears for the future have come to fruition, especially when he discovers a lower class of workers who spend their entire lives underground—a species that will soon evolve into the Morlocks of Wells’s <i>The Time Machine</i>.<br/>  <br/> “Even in the 21st century, Wells still speaks to our fears and dreams.” —<i>The Washington Post</i><br/>  <br/> “Nothing is more striking about Mr. Wells . . . than his power of lending freshness and vitality to some well-worn formula of fiction.”—<i>The Spectator</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. G. Wells
      </h2>
      
      <p class="authorDescription body article">The son of a professional cricketer and a lady&rsquo;s maid, H. G. Wells (1866&ndash;1946) served apprenticeships as a draper and a chemist&rsquo;s assistant before winning a scholarship to the prestigious Normal School of Science in London. While he is best remembered for his groundbreaking science fiction novels, including <I>The Time Machine</I>, <I>The War of the Worlds</I>, <I>The Invisible Man</I>, and <I>The Island of Doctor Moreau</I>, Wells also wrote extensively on politics and social matters and was one of the foremost public intellectuals of his day.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ae51e38